import { render, staticRenderFns } from "./assets_mark.vue?vue&type=template&id=54c43355&scoped=true"
import script from "./assets_mark.vue?vue&type=script&lang=js"
export * from "./assets_mark.vue?vue&type=script&lang=js"
import style0 from "./assets_mark.vue?vue&type=style&index=0&id=54c43355&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c43355",
  null
  
)

export default component.exports